
export default (state = {}, action) => {
  switch (action.type) {
    case 'LIST_EMAILS_BEGINS':
      return {
        loader: true,
        error: false,
        result: null,
      
      }
    case 'LIST_EMAILS_SUCCESS':
      return {
        loader: false,
        error: false,
        result: action.payload,
    
      }
    case 'LIST_EMAILS_FAILURE':
      return {
        loader: false,
        error: false,
        result: null,
      

      }

    default:
      return state
  }
}